const isEnabled = value =>
  value === true ||
  value === 1 ||
  ['true', '1'].includes(String(value).toLowerCase());

const isActiveIntegration = integration =>
  integration?.available === true &&
  integration?.configured === true &&
  integration?.connection_enabled !== false;

const enabledUnlessExplicitlyDisabled = value =>
  value == null || !['false', '0'].includes(String(value).toLowerCase());

const SGP_ACTION_KEYS = [
  'sgp_contract_lookup_enabled',
  'sgp_billing_enabled',
  'sgp_ticket_enabled',
  'sgp_ticket_management_enabled',
  'sgp_trust_release_enabled',
  'sgp_wifi_management_enabled',
  'sgp_service_password_enabled',
];

export const resolveVoiceCallCapabilitySources = (
  integrations = [],
  accountAttributes = {}
) => {
  const byKey = Object.fromEntries(
    integrations.map(integration => [integration.key, integration])
  );
  const abm = byKey.abm;
  const shopify = byKey.shopify;
  const abmCatalogActive =
    isActiveIntegration(abm) && isEnabled(abm.settings?.abm_catalog_enabled);
  const shopifyActive = isActiveIntegration(shopify);
  const shopifyPolicy = accountAttributes.shopify_action_policy || {};
  const shopifyCatalogActive =
    shopifyActive &&
    enabledUnlessExplicitlyDisabled(shopifyPolicy.shopify_catalog_enabled);
  const catalogSources = [
    ...(abmCatalogActive ? ['abm'] : []),
    ...(shopifyCatalogActive ? ['shopify'] : []),
  ];

  const nativeIntegrationNames = [
    ['sgp', 'SGP'],
    ['ixc', 'IXC'],
    ['mkauth', 'MK-Auth'],
    ['hubsoft', 'HubSoft'],
    ['siprov', 'Siprov'],
  ].flatMap(([key, name]) => {
    const integration = byKey[key];
    if (!isActiveIntegration(integration)) return [];
    if (
      key === 'sgp' &&
      !SGP_ACTION_KEYS.some(action => isEnabled(integration.settings?.[action]))
    ) {
      return [];
    }
    if (
      key === 'siprov' &&
      !isEnabled(integration.settings?.siprov_integration_enabled)
    ) {
      return [];
    }
    return [name];
  });

  return {
    catalog: catalogSources.join('_') || null,
    shopifyOrders:
      shopifyActive &&
      [
        'shopify_order_lookup_enabled',
        'shopify_order_details_enabled',
        'shopify_delivery_tracking_enabled',
      ].some(key => enabledUnlessExplicitlyDisabled(shopifyPolicy[key])),
    nativeIntegrationNames,
  };
};
